import { Calendar, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '@utils/api';
import { formatInboxTime } from '@utils/helpers';
import { useNotifications } from '@context/NotificationContext';
import { INBOX_READ_ROW, INBOX_ROW_FRAME, INBOX_UNREAD_ROW } from '@components/messages/inboxRowStyles';

const ActivityReminderInboxCard = ({ n, onReminderRead, isPulsing = false }) => {
  const navigate = useNavigate();
  const { refreshUnreadCount } = useNotifications();
  const activityTitle = n.activityId?.title || 'Vibe';
  const activityNavId = n.activityId?._id ?? n.activityId;
  const notifId = n._id ?? n.id;
  const isDay = n.type === 'activity_reminder_day';

  const handleClick = async () => {
    try {
      if (!n.isRead && notifId) {
        await api.patch(`/notifications/${notifId}/read`);
        await onReminderRead?.(notifId);
      }
    } catch {
      /* still refresh + navigate */
    }
    await refreshUnreadCount();
    if (activityNavId) {
      navigate(`/activity/${activityNavId}`);
    }
  };

  const unread = !n.isRead;
  const Icon = isDay ? Calendar : Clock;
  const boxClass = isDay
    ? 'bg-sky-100 text-sky-800 dark:bg-sky-500/20 dark:text-sky-200'
    : 'bg-violet-100 text-violet-800 dark:bg-violet-500/20 dark:text-violet-200';

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${INBOX_ROW_FRAME} ${unread ? INBOX_UNREAD_ROW : INBOX_READ_ROW} ${
        isPulsing ? 'animate-pulse-glow' : ''
      }`}
    >
      <div
        className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${boxClass}`}
      >
        <Icon size={22} strokeWidth={2} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <p className="font-semibold text-surface-900 dark:text-surface-50">
            <span className={isDay ? 'text-sky-800 dark:text-sky-200' : 'text-violet-800 dark:text-violet-200'}>
              {isDay ? 'Vibe today' : 'Starting in ~1 hour'}
            </span>
            <span className="mx-1.5 font-normal text-surface-400 dark:text-surface-500">·</span>
            <span className="font-medium text-surface-800 dark:text-surface-200">{activityTitle}</span>
          </p>
          <span className="shrink-0 text-xs text-surface-400">{formatInboxTime(n.createdAt)}</span>
        </div>
        <p className="mt-1 text-sm text-surface-500 dark:text-surface-400">
          {n.message?.trim() || (isDay ? 'Your scheduled vibe is today.' : 'This vibe is starting soon.')}
        </p>
      </div>
    </button>
  );
};

export default ActivityReminderInboxCard;
